// extracted by mini-css-extract-plugin
module.exports = {"item":"SequentialReveal_item__NT5gr","visible":"SequentialReveal_visible__QQuur"};